<template>
    <v-container fluid>
      <v-card>
        <v-toolbar color="secondary" flat dense>
          <v-toolbar-title>Production Details</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" small text to="/production-records">
            <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
          </v-btn>
        </v-toolbar>
        <v-card-text>

            <v-row class="text--primary heading-2">
                <v-col cols="12">
                <span>Title: {{ productionRecord.title }}</span><br>
                <span>Date: {{ productionRecord.DocDate }}</span><br>
                <span>Recorded By: {{ productionRecord.user.name }}</span><br>
                </v-col>
            </v-row>

          <v-row>
            <v-col cols="12" sm="12" md="6">
                <v-card>
                    <v-card-title>
                    <span class="text--primary heading-2">Raw Materials Used</span>
                    </v-card-title>
                    <v-card-text>
                    <v-row>
                        <v-col cols="12" sm="12" md="12">
                        <!-- start of table -->
                        <v-data-table
                            :items-per-page="pageItems"
                            :headers="rawHeaders"
                            :items="rawMaterials"
                            :search="search"
                            :mobile-breakpoint="zeroValue"
                        >
                        </v-data-table>
                        <!-- end -->
                        </v-col>
                    </v-row>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="12" sm="12" md="6">
                <v-card>
                    <v-card-title>
                    <span class="text--primary heading-2">Produced Goods</span>
                    </v-card-title>
                    <v-card-text>
                    <v-row>
                        <v-col cols="12" sm="12" md="12">
                        <!-- start of table -->
                        <v-data-table
                            :items-per-page="pageItems"
                            :headers="producedHeaders"
                            :items="producedItems"
                            :search="search"
                            :mobile-breakpoint="zeroValue"
                        >
                        </v-data-table>
                        <!-- end -->
                        </v-col>
                    </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-container>
  </template>
    
    <script>
  export default {
    data: () => ({
      search: "",
      customersDialog: false,
      productionRecord: {},
      rawMaterials: [],
      producedItems: [],
      loader: false,
      zeroValue: 0,
      pageItems: 100,
      date: null,
      headers: [
        { text: "Title", value: "title" },
        { text: "Date", value: "DocDate" },
        { text: "Recorded By", value: "user.name" },
        { text: "More Details", value: "action" }
      ],
      rawHeaders: [
        { text: "Product", value: "product.Name" },
        { text: "Quantity", value: "Quantity" },
        { text: "Price", value: "Price" }
      ],
      producedHeaders: [
        { text: "Product", value: "product.Name" },
        { text: "Quantity", value: "Quantity" },
        { text: "Price", value: "Price" }
      ],
      records: [],
      excelFile: null
    }),
    watch: {
    "$route.params.id": {
      handler: "getById",
      immediate: true,
    },
  },
    methods: {
      setDate(myDate) {
        this.date = myDate;
      },
      getById(val) {
      const self = this;
      this.$store
        .dispatch("get", `/production-details/${val}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.productionRecord = res.ResponseData;
            console.log(res.ResponseData);
            self.rawMaterials = res.ResponseData.raw_material_used;
            self.producedItems = res.ResponseData.produced_goods;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    },
    created() {
   
    }
  };
  </script>